import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import styles from './vacancyConfiguration.module.scss';
import { CustomTextField } from '../../../shared/customTextField';
import { CustomButton } from '../../../shared/customButton';
import * as yup from 'yup';
import { Formik } from 'formik';
import { toast } from 'react-toastify';
import { getPresignedURLCompanyLogo, submitCompanyInitialStageData, uploadCompanyLogo, checkVacancyPageUrlAvailability } from '../../../../services/util/company';
import { useHistory } from 'react-router-dom';

const AddVacancyConfiguration = (props) => {

    let [isSubmitPending, setIsSubmitPending] = useState(false);
    const [isCheckUrlAvailabilityPending, setIsCheckUrlAvailabilityPending] = useState(false);
    const [isUrlAlreadyTaken, setIsUrlAlreadyTaken] = useState(true);
    const [isUrlAlreadyTakenMsgReady, setIsUrlAlreadyTakenMsgReady] = useState(false);
    const [emailExists, setEmailExists] = useState(true);
    const [emailExistsTextStatus, setRmailExistsTextStatus] = useState(false);
    const history = useHistory();

    //yup validations
    const schema = yup.object({
        pageURL: yup.string().trim().matches(/^[a-zA-Z0-9-]+$/, 'Only alphanumeric characters and hyphen (-) are allowed').min(3, 'At least 3 alphanumeric characters should be included').max(60, 'Character length should be less than 60').required('Required')
    });

    //on submit function
    const onSubmit = async (values) => {
        setIsSubmitPending(true);
        props.setCompanyPageURL(values);
        if (props.companyDetails.companyLogo && props.companyDetails.companyLogo.length > 0) {

            let companyLogoImgType = ((props.companyDetails.companyLogo[0].type).split('/')[1]).toLowerCase();
            let preSignedURL = await getPresignedURLCompanyLogo(companyLogoImgType);

            if (preSignedURL.success === true) {

                let imageUploadRespond = await uploadCompanyLogo(preSignedURL.data.presigned_url, props.companyDetails.companyLogo[0]);
                if (imageUploadRespond.status === 200) {

                    let updateRespond = await submitCompanyInitialStageData(companyLogoImgType, values.pageURL, props.companyDetails.description);
                    if (updateRespond.success === true) {
                        setIsSubmitPending(false);
                        props.handleClose();
                    } else {
                        setIsSubmitPending(false);
                    }
                } else {
                    setIsSubmitPending(false);
                }
            } else {
                setIsSubmitPending(false);
            }

            setTimeout(function () {
                history.push(`/company/pipelines`);
            }, 1400);
        }
    }

    const handleOnBlur = async (e, is_valid) => {
        const { name, value } = e.target;

        if (is_valid && value.trim().length > 0) {
            setIsCheckUrlAvailabilityPending(true);

            try {
                const response = await checkVacancyPageUrlAvailability(value);

                if (response.success === true) {
                    setIsUrlAlreadyTakenMsgReady(true)
                    setIsUrlAlreadyTaken(response.data.is_already_available);
                    setIsCheckUrlAvailabilityPending(false);
                }
            } catch (error) {
                console.error('Error checking email:', error);
            }
        }

    }

    const resetAvailabilityCheck = () => {
        setIsCheckUrlAvailabilityPending(false);
        setIsUrlAlreadyTakenMsgReady(false);
        setIsUrlAlreadyTaken(false)
    }


    return (
        <div>
            <Formik
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                // handleOnBlur={(values) => handleOnBlur(values)}
                initialValues={{ pageURL: props.companyDetails.pageURL }}
            >

                {({
                    values,
                    errors,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    submitCount,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <p className={styles.bodyMainText}>Enter a custom URL for vacancy pages. ex:- apple-careers</p>
                        <div className={styles.vacancyTextDiv}>
                            <CustomTextField
                                id="vacancy_url_edit"
                                isVacancyPageUrlInput={true}
                                urlPreview={`${process.env.REACT_APP_VACANCY_PAGE_URL_BASE_URL}${values.pageURL}`}
                                placeholder="your-company-name-careers"
                                controlId="pageURL"
                                type="text"
                                name="pageURL"
                                classType="defaultTextBox"
                                editTextField="true"
                                handleOnChange={e => { handleChange(e); resetAvailabilityCheck(); }}
                                value={values.pageURL}
                                errorMessage={errors.pageURL}
                                isInvalid={submitCount > 0 && !!errors.pageURL}
                                showDefaultErrorMsg={values.pageURL ? false : true}
                                handleOnBlur={(e) => handleOnBlur(e, !!!errors.pageURL)}
                            />
                        </div>
                        {isCheckUrlAvailabilityPending && <p className={styles.checkingMsg}><i className="fas fa-circle-notch fa-spin"></i> Checking availability</p>}
                        {isUrlAlreadyTakenMsgReady && <p className={!isUrlAlreadyTaken ? styles.successMsg : styles.errorMsg}>{!isUrlAlreadyTaken ? 'The URL is available for you. Please click Submit to save.' : "The URL you entered is already taken by another company. Please enter a different path"}</p>}
                        <hr className={styles.dividerLine} />
                        <div className="mt-3 mb-3 d-flex flex-row-reverse">
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="pipeline_additional_detail_confirm"
                                    buttonType="submit"
                                    label="Submit"
                                    type="primaryBtn"
                                    backicon={
                                        isSubmitPending === true ? (<i className="fas fa-circle-notch fa-spin"></i>)
                                            : ''
                                    }
                                    disabled={(isSubmitPending || isCheckUrlAvailabilityPending || isUrlAlreadyTaken) ? true : false}
                                />
                            </div>
                            <div className={styles.navigateBtnCol}>
                                <CustomButton
                                    id="pipeline_additional_detail_cancel"
                                    buttonType="button"
                                    label="Back"
                                    type="defaultBtn"
                                    handleClick={() => props.previousPage(2)}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>


        </div>
    )
}

export default AddVacancyConfiguration;
